<script>
const hotelCostListReport = importVueComp('components/reports', 'HotelCostListReport', 'custom');


export default {
    name: "custom-hotel-costlist-report",
    mixins: [hotelCostListReport],
    data() {
        return {
            hColumns: ['HotelName', 'HotelComment', 'StartDate', 'EndDate', 'RoomCategory', 'SGL', 'DBL', 'TPL', 'CurrencyId', 'NetBy'],
        };
    },
}
</script>
